import { FocusableOption, FocusMonitor, FocusOrigin, ListKeyManagerOption } from '@angular/cdk/a11y';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { AfterViewInit, Component, ElementRef, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';

/**
 * Used to indicate a menu item.
 * 
 * Documentation see `MenuComponent`.
 */
@Component({
  // tslint:disable-next-line: component-selector
  selector: '[app-menu-item]',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent implements OnInit, AfterViewInit, OnDestroy, ListKeyManagerOption, FocusableOption {

  public focused = false;

  @HostBinding('attr.role')
  public readonly role = 'menuitem';

  @HostBinding('class.menu-item')
  public readonly menuItemClass = true;

  @Input()
  @HostBinding('class.disabled')
  @HostBinding('attr.aria-disabled')
  get disabled() {
    return this._disabled;
  }
  set disabled(value: any) {
    this._disabled = coerceBooleanProperty(value);
  }
  private _disabled = false;

  /** Returns the text inside the dropdown item */
  public get viewValue(): string {
    return this.elem.nativeElement.textContent.trim() ?? '';
  }

  /**
   * Returns the height of the HTML element (offsetHeight)
   */
   public get elementHeight(): number {
    return this.elem.nativeElement.offsetHeight;
  }

  /**
   * Returns the position of the HTML element with respect to the parent element (dropdown container, i.e. returns offsetTop)
   */
  public get elementOffsetTop(): number {
    return this.elem.nativeElement.offsetTop;
  }

  constructor(
    private elem: ElementRef<HTMLElement>,
    private focusMonitor: FocusMonitor
  ) { }

  ngOnInit(): void {
  }

  public ngOnDestroy() {
    this.focusMonitor.stopMonitoring(this.elem);
  }

  public ngAfterViewInit() {
    this.focusMonitor.monitor(this.elem, false).subscribe(value => {
      this.focused = value != null ? true : false;
    });
  }

  public getLabel(): any {
    return this.viewValue;
  }

  public focus(origin?: FocusOrigin) {
    if (this.focusMonitor && origin != null) {
      this.focusMonitor.focusVia(this.elem, origin);
    } else {
      this.elem.nativeElement.focus();
    }
  }
}
